import React from "react"
import styled from "styled-components"
import { CheckCircle } from "lucide-react"

const Container = styled.div`
  padding: 2rem 1.5rem;
  text-align: center;
`

const IconContainer = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: #dcfce7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem auto;
`

const StyledCheckCircle = styled(CheckCircle)`
  width: 2rem;
  height: 2rem;
  color: #16a34a;
`

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #166534;
  margin-bottom: 0.5rem;
  line-height: 1.4;
`

const Description = styled.p`
  font-size: 0.875rem;
  color: #15803d;
  margin: 0;
`

const PaymentCardSuccess = () => {
  return (
    <Container>
      <IconContainer>
        <StyledCheckCircle />
      </IconContainer>
      <Title>Método de pagamento efetuado com sucesso</Title>
      <Description>Seu pagamento foi processado e confirmado</Description>
    </Container>
  )
}

export default PaymentCardSuccess